import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
export default function IconTextButton({
	color,
	size,
	icon,
	children,
	...props
}) {
	return (
		<IconButton
			color={color}
			size={size}
			{...props}
			sx={{
				flexDirection: "column",
				width: 60,
				height: 60,
				overflow: "visible",
				ml: 1,
			}}
		>
			{icon}
			<Typography
				variant="caption"
				sx={{ position: "relative", width: "max-content" }}
			>
				{children}
			</Typography>
		</IconButton>
	);
}
